import { createContext } from "react";

interface DefaultTemplatesContextProps {
  openPanel: () => void;
}

export const DefaultTemplatesContext = createContext({} as DefaultTemplatesContextProps);
